import { GameElementSpecificationsInterface } from "../../interfaces/game-element-specifications-interface";
import { AlingString, ColorsString, GameFontStylesString, textFontSize } from "../../settings/game-constants-strings/text-styles-string";

export const HelpSceneElementsSpecifications: GameElementSpecificationsInterface[] = [
    {
        type: 'image',
        element: 'background',
        assetName: 'modal-scene-background',
        name: 'scene-backgroud',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 1366,
            objectHeight: 770,
            objectPositionX: 683,
            objectPositionY: 384,
        }
    },
    {
        type: 'image',
        element: 'background',
        assetName: 'modal-scene-background',
        name: 'scene-backgroud',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 1366,
            objectHeight: 770,
            objectPositionX: 683,
            objectPositionY: 384,
        }
    },
    {
        type: 'image',
        element: 'background',
        assetName: 'modal-scene-background',
        name: 'scene-backgroud',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 1366,
            objectHeight: 770,
            objectPositionX: 683,
            objectPositionY: 384,
        }
    },
    {
        type: 'image',
        element: 'background',
        assetName: 'panel-card-background',
        name: 'help-panel-backgroud',
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 1066,
            objectHeight: 600,
            objectPositionX: 683,
            objectPositionY: 384,
        },
    },
    {
        type: 'button',
        element: 'bottom-title-button',
        assetName: 'close-button-background',
        name: 'close-button',
        content: 'CERRAR',
        style: {
            fontFamily: GameFontStylesString.BASE_FONT,
            color: ColorsString.RED_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: textFontSize.Small.fontSize,
            strokeThickness: textFontSize.Small.strokeThickness,
            stroke: ColorsString.WHITE_HEXADECIMAL_STRING
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 90,
            objectHeight: 110,
            objectPositionX: 1145,
            objectPositionY: 150,
        },
    },
    {
        type: 'text',
        element: 'title',
        name: 'scene-title',
        content: 'AYUDA',
        style: {
            fontFamily: GameFontStylesString.BASE_FONT,
            color: ColorsString.WHITE_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: textFontSize.Regular.fontSize,
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 720,
            objectHeight: 70,
            objectPositionX: 683,
            objectPositionY: 190,
        },
    },
    {
        type: 'text',
        element: 'content',
        name: 'game-help',
        content: 'Cambia el color de los bloques con un clic, al mismo color que tiene la esfera,' +
                 ' para que esta pueda seguir rebotando.\n\n' +
                 'Intenta llegar hasta el último bloque del juego y obtén el mejor puntaje.',
        style: {
            fontFamily: GameFontStylesString.SMALL_FONT,
            color: ColorsString.WHITE_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            fontSize: '27px',
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 800,
            objectHeight: 200,
            objectPositionX: 683,
            objectPositionY: 350,
        },
    },
    // {
    //     type: 'text',
    //     element: 'paragraph',
    //     name: 'developer-info',
    //     content: 'CRISWEB.ME - info.crisweb@gmail.com',
    //     style: {
    //         fontFamily: GameFontStylesString.SMALL_FONT,
    //         color: ColorsString.WHITE_HEXADECIMAL_STRING,
    //         align: AlingString.CENTER_STRING,
    //         strokeThickness: 1,
    //         stroke: ColorsString.BLUE_HEXADECIMAL_STRING,
    //         fontSize: textFontSize.VerySmall.fontSize,
    //     },
    //     scale: {
    //         objectWidthRatio: 1,
    //         objectHeightRatio: 1,
    //         objectWidth: 800,
    //         objectHeight: 100,
    //         objectPositionX: 683,
    //         objectPositionY: 585,
    //     },
    // }
    {
        type: 'text',
        element: 'paragraph',
        name: 'developer-info',
        content: 'DESAROLLADOR:\nIng. Jonathan Paul Caiza LL. \n\n' +
                 'CRISWEB.ME © 2021                                               QUITO - ECUADOR ',
        style: {
            fontFamily: GameFontStylesString.SMALL_FONT,
            color: ColorsString.WHITE_HEXADECIMAL_STRING,
            align: AlingString.CENTER_STRING,
            // strokeThickness: 1,
            // stroke: ColorsString.WHITE_HEXADECIMAL_STRING,
            fontSize: textFontSize.VerySmall.fontSize,
        },
        scale: {
            objectWidthRatio: 1,
            objectHeightRatio: 1,
            objectWidth: 900,
            objectHeight: 250,
            objectPositionX: 683,
            objectPositionY: 565,
        },
    }
]